export default {
    resetPassword: '',
    forgotPassword: '',
}
